import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { ChangeOfficeService as ChangeOfficeAuthService } from '@bilancio/auth';
import { BehaviorSubject } from 'rxjs';
import { UsersManagementService } from '../../manage/users-management/users-management.service';
import { ChangeOfficeService } from './change-office.service';
import { AsyncActions, SuperStore, AsyncSelectors } from '@bilancio/root-store';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'app-change-office',
    templateUrl: './change-office.component.html',
    styleUrls: ['./change-office.component.scss'],
    standalone: false
})
export class ChangeOfficeComponent {
    listVisible$ = new BehaviorSubject(false);
    clicked$ = new BehaviorSubject(false);
    private readonly asyncConnect = this.store.selectSignal(
        AsyncSelectors.getAsyncConnection
    );

    constructor(
        readonly changeOfficeService: ChangeOfficeService,
        private readonly changeOfficeAuthService: ChangeOfficeAuthService,
        private readonly userService: UsersManagementService,
        private readonly router: Router,
        private readonly store: SuperStore
    ) {}

    async changeOffice(
        officeId: number,
        tenantId: string,
        currentOfficeId: number,
        currentTenantId: string
    ) {
        this.changeListVisible(false);
        // this.changeOfficeService.currentOffice$.next(office);
        // eslint-disable-next-line no-void

        // Disconnessione forzata di AMQP prima di cambiare ufficio per evitare di ricevere messaggi
        // non pertinenti al nuovo ufficio
        this.store.dispatch(
            AsyncActions.asyncAmqpForceDisconnect({
                asyncConnect: this.asyncConnect(),
                reconnect: false
            })
        );

        await this.changeOfficeAuthService.changeOffice(officeId, tenantId);
        this.changeOfficeService.selectCurrentOffice(officeId);
        this.userService.flush();
        if (officeId !== currentOfficeId || tenantId !== currentTenantId) {
            this.router
                .navigateByUrl('/white', { skipLocationChange: true })
                .then(() => this.router.navigate(['/user/dashboard']));
        }
    }

    changeListVisible(evt: boolean) {
        this.clicked$.next(evt);
        this.listVisible$.next(evt);
    }
}
